<template>
  <div class="rounds d-flex bg-ui-panel" :class="{'is-scrolling': game.round > 1}">
    <!-- TODO active round -->
    <transition name="v-scale">
      <div v-if="round" class="active-crate d-flex justify-center flex-column pr-12 pl-3">
        <h4 class="text-caption font-weight-bold text-truncate" v-text="round.name" />
        <scrap :amount="round.price" class="text-body-2 mb-1" />
      </div>
    </transition>

    <div
      class="crates py-1"
      :class="round && 'ml-n8'"
      :style="{
        '--crateSize': `${crateSize}px`,
        '--offsetX': `${cratesOffset}px`,
      }"
    >
      <BattleListingRound
        v-for="(crate, i) in rounds"
        :key="i"
        :game-case="crate" :crate-size="crateSize"
        :opened="game.round > i + 1"
        @contextmenu.native.prevent="$emit('inspect', crate)"
      />
    </div>

    <div class="game-status text-body-2 pr-4">
      <span v-if="game.status === GAME_STATUS.open">{{ rounds.length }} rounds</span>
      <span v-else-if="game.status === GAME_STATUS.locked">Starting</span>
      <span v-else-if="game.status === GAME_STATUS.rolling" class="round-status text-body-1 font-weight-bold">{{ game.round }}/{{ rounds.length }}</span>
      <span v-else-if="game.status === GAME_STATUS.complete">Finished</span>
    </div>
  </div>
</template>

<script>
import BattleListingRound from '@/views/games/CaseBattles/components/BattleListingRound'
import { GAME_STATUS } from '@/views/games/CaseBattles/utils'

export default {
  components: {
    BattleListingRound,
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
    crateSize: {
      type: Number,
      default: 48,
    },
  },
  data() {
    return {}
  },
  computed: {
    GAME_STATUS() {
      return GAME_STATUS
    },
    cratesOffset() {
      if (!this.game.round) return 10

      const box = (this.crateSize + 4)
      return -((this.game.round - 1) * box - 4)
    },
    rounds() {
      const { cases } = this.game
      return this.game.config.rounds.map(id => cases[id])
    },
    round() {
      return this.rounds[this.game.round - 1]
    },
  },
}
</script>

<style lang="scss" scoped>
.rounds {
  overflow: hidden;
  position: relative;

  .active-crate {
    z-index: 3;
    background: linear-gradient(to right, grey(300) 50%, transparent);
    transition: transform 0.3s ease;
    pointer-events: none;
  }

  &::after {
    position: absolute;
    z-index: 2;
    top: 0;
    height: 100%;
    content: '';
    pointer-events: none;
  }

  &::after {
    right: 0;
    width: 35%;
    background: linear-gradient(to left, grey(300) 9%, transparent 90%);
  }

  &.is-scrolling {
    &::before {
      opacity: 1;
    }
  }

  .crates {
    display: flex;
    transition: transform 0.5s cubic-bezier(0.23, 1, 0.32, 1);
    transform: translateX(var(--offsetX));
    will-change: transform;

    .round-case {
      width: var(--crateSize);
      height: 100%;
      margin-right: 4px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }

  .game-status {
    position: absolute;
    z-index: 3;
    top: 50%;
    right: 0;
    text-align: right;
    transform: translateY(-50%);
    pointer-events: none;

    span {
      position: relative;
      z-index: 1;
    }

    .round-status {
      letter-spacing: 2px !important;
    }
  }
}
</style>
